import {
  parseSearchArrayValue,
  parseSearchNumberValue,
  parseSearchStringValue,
} from 'infrastructure/functions/parse-query-string';
import { useQueryFilterNew } from 'infrastructure/hooks/common/use-query-param-new';

import type { TParseFunctions } from 'infrastructure/hooks/common/use-query-param-new';
import type { TPatientEngagementReportFilter } from './types';

const today = new Date();

const defaultFilter: TPatientEngagementReportFilter = {
  page: 1,
  clinicGuid: [],
  parentClinicGuid: [],
  year: today.getFullYear(),
  month: today.getMonth() + 1,
};

const parseFunctions: TParseFunctions<TPatientEngagementReportFilter> = {
  page: parseSearchNumberValue,
  clinicGuid: parseSearchArrayValue,
  parentClinicGuid: parseSearchArrayValue,
  doctorGuid: parseSearchStringValue,
  status: parseSearchStringValue,
  patientGuid: parseSearchStringValue,
  engagementAttempts: parseSearchStringValue,
  year: parseSearchNumberValue,
  month: parseSearchNumberValue,
};

export const usePatientEngagementReportFilter = () =>
  useQueryFilterNew<TPatientEngagementReportFilter>(
    defaultFilter,
    parseFunctions,
    ['page', 'year', 'month'],
  );
